import React from "react";

import {
  useDropsApi,
  IDrop
} from "src/core/drops/api/drops.api";
import { getDropTableColumns } from "src/core/shared/components/tables/dropsTableColumns";
import { ActionButton } from "src/library/components/Button";
import Table from "src/core/dashboard/components/widgets/table/Table";
import { ITableInstance } from "src/library/components/Tables/Table";
import {
  FilterParams,
  PaginatedParams
} from "src/library/utils";
import { PageProps } from "src/pages/Router/routes";

export interface PriceChangeDropsTabProps {
  priceCodeId: number;
}

const defaultPagination: PaginatedParams<IDrop> = {
  page: 0,
  limit: 20,
  offset: 0,
  sort: [ [ "name", "ASC" ] ]
};

/**
 * displays drops associated to price code
 */
const PriceChangeDropsTab: React.ReactFCWithChildren<PageProps<PriceChangeDropsTabProps>> = ({ priceCodeId, ...props }) => {
  const { history, terminology } = props;
  const TableRef = React.useRef<ITableInstance<IDrop>>(null);
  const [ dropsResponse, getDrops ] = useDropsApi("LIST_DROPS");
  const dropsData = dropsResponse.data;

  const columns = React.useMemo(() => {
    return getDropTableColumns({
      actionButton: info => {
        return (
          <ActionButton
            key={`action-${info.row.original.id}`}
            title="Actions"
            items={[
              {
                title: "View",
                action: () => {
                  history.push(`/admin/customers/${info.row.original.customerId}/drops/${info.row.original.id}/contact-details`);
                },
                newTabPath: `/admin/customers/${info.row.original.customerId}/drops/${info.row.original.id}/contact-details`
              }
            ]}
            loading={dropsResponse.pending}
          />
        );
      },
      terminology,
      selectedColumns: [
        "customer",
        "dropNumber",
        "name",
        "address",
        "postcode",
        "status",
        "lastOrderUpdate",
        "actions"
      ]

    });
  }, [ history, terminology ]);

  const onFetchData = React.useCallback(
    (params: {filters: FilterParams<IDrop>, pagination: PaginatedParams<IDrop>}) => {
      getDrops({
        pagination: params.pagination,
        filters: {
          ...params.filters,
          priceCodeId
        }
      });
    },
    [ priceCodeId, getDrops ]
  );

  return (
    <Table
      ref={TableRef}
      error={dropsResponse.error}
      tableOf={terminology.drop.plural.text}
      loading={dropsResponse.pending}
      data={dropsData ? dropsData.result : []}
      onFetchData={onFetchData}
      rowCount={dropsData ? dropsData.count : 0}
      pageCount={dropsData ? dropsData.pages : 0}
      defaultPagination={defaultPagination}
      mainAction={row => history.push(`/admin/customers/${row.original.customerId}/drops/${row.original.id}/orders`)}
      columns={columns}
    />

  );
};

export default PriceChangeDropsTab;
